import React, {  useEffect } from 'react';
import './popup.component.scss';
import {stopBackgroundScrolling} from "../../../common/utils/app.utils";
const PopupComponent = props => {
    useEffect(() => {
        stopBackgroundScrolling(true)
    }, []);
    const closePopup = value =>{
        stopBackgroundScrolling();
        if(value === 'yes'){
            onClickYes()
        } else {
            toggleSelectPopUp();
        }

    }
    let { popupData, toggleSelectPopUp, onClickYes,newCard } = props;
    return (
        <div className="modal-body-custom-popup">
            <div className={`modal-card ${newCard ? 'modal-card-new' : ''}`}>
                <div className="modal-header">
                    <h5>{popupData && popupData.title ? popupData.title : 'Thank you!'} </h5>
                    {
                        popupData && !popupData.buttonYes &&
                        <span className="material-icons close" onClick={() => closePopup()}>
                            close
                         </span>
                    }

                </div>
                <div className="modal-contents" dangerouslySetInnerHTML={{__html: popupData && popupData.message ? popupData.message : 'add text here.'}}>
                </div>
                <div className="modal-footer" align="right">

                    {
                        popupData.buttonNo &&
                        <button className="btn btn-no-bg mr-32" onClick={closePopup}>{popupData.buttonNo}</button>
                    }
                    {
                        popupData.buttonYes &&
                        <button className="btn activebtn" onClick={()=>closePopup()}>{popupData.buttonYes}</button>
                    }


                </div>
            </div>
        </div>
    )
}

export default PopupComponent
